/* Nolae blog — article templates. Built by scripts/build-js.py in nolae-blog-theme
   from the prototype's scripts; do not edit by hand. */

/* ————— The breadcrumb trail on the theme's header —————
   The trail pins under Focal's sticky header (whatever height it has at
   the moment — it shrinks once scrolled) and, while pinned, drops its white
   pill and reads its colours off what is behind it, part by part. */
(function () {
  var LUMA = 0.6;
  var BAND = 0.03;
  var LUMA_STEP = 40;
  // The trail is on the article, category and archive pages; the index has
  // none, but its header hides and returns the same way (glass.js runs on
  // every page of the prototype).
  var crumbsEl = document.querySelector(".nolae-blog .crumbs");
  function toRgb(css) {
    var m = /^rgba?\(([^)]+)\)/.exec(css || "");
    if (!m) return null;
    var p = m[1].split(",").map(parseFloat);
    if (p.length > 3 && p[3] === 0) return null; // fully transparent
    return p;
  }

  /** Nearest painted background behind `el`, walking up past transparents. */
  function backdropOf(el) {
    for (var n = el; n && n !== document.documentElement; n = n.parentElement) {
      var rgb = toRgb(getComputedStyle(n).backgroundColor);
      if (rgb) return rgb;
    }
    return [255, 255, 255];
  }

  function luminance(rgb) {
    var lin = rgb.slice(0, 3).map(function (v) {
      var c = v / 255;
      return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * lin[0] + 0.7152 * lin[1] + 0.0722 * lin[2];
  }

  /* ————— Photographs —————
     backdropOf() reads painted background colours, which is right for the
     storefront's sections but says "white" for an <img>. Behind the pinned
     breadcrumb trail the backdrop is mostly article covers, so those are
     measured for real: the image is drawn to an 8×8 canvas and its pixels
     averaged. Needs the image to be CORS-readable (the cards set
     crossorigin, and the CDN allows it); a tainted or failed read counts as
     light. Cached per URL; the first sample of a new image comes back after
     it loads, via a nudge on the scroll event. */
  var lumaCache = {};

  function imageLuma(img) {
    var src = img.currentSrc || img.src;
    if (!src) return null;
    var hit = lumaCache[src];
    if (hit !== undefined) return hit === "pending" ? null : hit;
    lumaCache[src] = "pending";
    var probe = new Image();
    probe.crossOrigin = "anonymous";
    probe.onload = function () {
      try {
        var c = document.createElement("canvas");
        c.width = 8; c.height = 8;
        var ctx = c.getContext("2d");
        ctx.drawImage(probe, 0, 0, 8, 8);
        var d = ctx.getImageData(0, 0, 8, 8).data;
        var sum = 0;
        for (var i = 0; i < d.length; i += 4) sum += luminance([d[i], d[i + 1], d[i + 2]]);
        lumaCache[src] = sum / (d.length / 4);
      } catch (e) {
        lumaCache[src] = 1;
      }
      window.dispatchEvent(new Event("scroll"));
    };
    probe.onerror = function () { lumaCache[src] = 1; };
    probe.src = src;
    return null;
  }

  /** Luminance of whatever is painted at (x, y), ignoring `bar` itself: a
   *  photograph's real average, otherwise the nearest background colour. */
  function lumaAt(x, y, bar) {
    var stack = document.elementsFromPoint(x, y);
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (bar.contains(el)) continue;
      if (el.tagName === "IMG") return imageLuma(el);
      return luminance(backdropOf(el));
    }
    return 1;
  }

  /** Mean luminance just below the bar, sampled at three points across it. */

  var crumbs = crumbsEl;
  var lastCrumbY = -1e9;
  var BARE = ".crumb--home a, .crumb-chev, .crumb-slash, .crumb-w, .crumb-here";

  /* On a desktop the current page's name is split into words (.crumb-w),
     each its own part: a long article title can run from the bare page onto
     a cover, and word by word the dark stretch goes white while the rest
     stays as it is. On a phone (≤768px) the name is one part, measured
     whole — the trail is centred over a full-width column there, so it is
     over one thing or the other. Redone when a resize crosses the line. */
  var WORDS_FROM = window.matchMedia("(min-width: 769px)");

  function splitWords() {
    if (!crumbs) return;
    var want = WORDS_FROM.matches;
    crumbs.querySelectorAll(".crumb-here").forEach(function (here) {
      var split = !!here.querySelector(".crumb-w");
      if (split === want) return;
      if (!want) { here.textContent = here.textContent; here.classList.remove("is-dark"); return; }
      var words = here.textContent.split(/(\s+)/);
      here.textContent = "";
      words.forEach(function (w) {
        if (!w) return;
        if (/^\s+$/.test(w)) { here.appendChild(document.createTextNode(w)); return; }
        var span = document.createElement("span");
        span.className = "crumb-w";
        span.textContent = w;
        here.appendChild(span);
      });
    });
    lastCrumbY = -1e9;
  }
  splitWords();
  window.addEventListener("resize", splitWords);

  /** The trail's bare parts: the name itself only while it is not split. */
  function bareParts() {
    var all = crumbs.querySelectorAll(BARE);
    var parts = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].classList.contains("crumb-here") && all[i].querySelector(".crumb-w")) continue;
      parts.push(all[i]);
    }
    return parts;
  }

  /** One element's backdrop: its mean luminance. Small parts sample their
   *  centre; a wide one, five points across. null while an image behind it
   *  is still loading. */
  function backdropOfPart(el) {
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return null;
    var mid = Math.round(r.top + r.height / 2);
    var ts = r.width > 60 ? [0.06, 0.28, 0.5, 0.72, 0.94] : [0.5];
    var sum = 0, n = 0;
    for (var i = 0; i < ts.length; i++) {
      var l = lumaAt(Math.round(r.left + r.width * ts[i]), mid, crumbs);
      if (l === null) continue; // an image still loading: sample again later
      sum += l; n++;
    }
    if (!n) return null;
    return { mean: sum / n };
  }

  function applyCrumbs() {
    if (!crumbs) return;
    var parts = bareParts();
    if (!crumbs.classList.contains("is-pinned")) {
      for (var j = 0; j < parts.length; j++) parts[j].classList.remove("is-dark");
      lastCrumbY = -1e9;
      return;
    }
    var y = window.scrollY;
    if (Math.abs(y - lastCrumbY) < LUMA_STEP) return;
    var measured = false;
    for (var i = 0; i < parts.length; i++) {
      var b = backdropOfPart(parts[i]);
      if (!b) continue; // keep this part's last skin, try again next event
      measured = true;
      var el = parts[i];
      if (b.mean < LUMA - BAND) el.classList.add("is-dark");
      else if (b.mean > LUMA + BAND) el.classList.remove("is-dark");
    }
    if (measured) lastCrumbY = y;
  }


  var headerEl = document.querySelector('.shopify-section--header, [id^="shopify-section"][id$="__header"]');
  function headerSticky() {
    if (!headerEl) return false;
    var cs = getComputedStyle(headerEl);
    return cs.position === "sticky" || cs.position === "fixed";
  }
  /** Where the trail parks: the header's resting bottom edge — its height,
   *  plus whatever is still above it near the top of the page — or the top
   *  of the window while the header is away. Read without the slide, so the
   *  trail's own `top` transition runs in step with the header's. */
  function chromeTop() {
    if (up || !headerSticky()) return 0;
    var r = headerEl.getBoundingClientRect();
    return Math.max(0, r.top) + headerEl.offsetHeight;
  }

  /* ————— Auto-hiding header, as in the prototype —————
     Scrolling down slides the store header away; scrolling back up brings
     it back (html.nolae-chrome-up, blog-article.css). Asymmetric on purpose:
     getting out of the way is immediate, coming back asks for a deliberate
     run of scrolling, so the bar does not fly in on a twitch of the wheel.
     Back at the top it is part of the opening composition again. */
  var up = false;
  var lastY = window.scrollY;
  var run = 0;
  var DELTA = 2, HIDE_AFTER = 24, REVEAL_AFTER = 120;
  function setUp(v) {
    if (v && document.body.classList.contains("lock-all")) v = false; // a drawer is open
    if (v === up) return;
    up = v;
    document.documentElement.classList.toggle("nolae-chrome-up", v);
    // The chrome is sliding: re-measure across the 320ms transition.
    [80, 200, 340].forEach(function (ms) { setTimeout(measure, ms); });
  }
  function autoHide() {
    if (!headerEl) return;
    var y = window.scrollY;
    var diff = y - lastY;
    if (Math.abs(diff) < DELTA) return;
    lastY = y;
    if (diff > 0 !== run > 0) run = 0;
    run += diff;
    if (y <= headerEl.offsetHeight) { run = 0; setUp(false); return; }
    if (run >= HIDE_AFTER) setUp(true);
    else if (run <= -REVEAL_AFTER) setUp(false);
  }

  /* The frosted band the pinned trail rides on: one sheet of glass from
     the top of the window down to the trail's lower edge, the header's own
     recipe (20% white, 20px blur), just under the header in the stacking
     order. While it is up the theme's own glass — the scrolled header's
     background and 1px border, and on a phone its body::before band — is
     switched off (blog-article.css, body.nolae-glass-on), so header and
     trail sit on the same surface instead of two blurs meeting at a seam. */
  var band = document.createElement("div");
  band.className = "nolae-glass";
  band.setAttribute("aria-hidden", "true");
  band.style.cssText = "position:fixed;left:0;right:0;top:0;height:0;background:rgba(255,255,255,0.2);-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px);z-index:3;pointer-events:none;";
  document.body.appendChild(band);
  var lastTop = -1;
  function measure() {
    autoHide();
    if (!crumbsEl) return;
    var top = Math.round(chromeTop());
    if (top !== lastTop) { crumbsEl.style.setProperty("--chrome-top", top + "px"); lastTop = top; }
    var r = crumbsEl.getBoundingClientRect();
    // Pinned: parked at its offset, or riding along while the offset moves.
    var pinned = window.scrollY > 0 && (r.top <= top + 2 || (up && r.top <= lastRestTop + 2));
    crumbsEl.classList.toggle("is-pinned", pinned);
    band.style.height = (pinned ? Math.max(0, Math.round(r.bottom)) : 0) + "px";
    document.body.classList.toggle("nolae-glass-on", pinned);
    applyCrumbs();
  }
  var lastRestTop = 0;
  if (headerEl) lastRestTop = headerEl.offsetHeight;
  measure();
  window.addEventListener("scroll", measure, { passive: true });
  window.addEventListener("resize", measure);
  /* Focal's header shrinks and slides after the scroll stops, with no scroll
     event to go with it: the trail lands on its sticky offset a beat after
     the last measure. So the header's size is observed, and there is one
     late measure after each scroll. */
  if (headerEl && window.ResizeObserver) new ResizeObserver(function () { lastRestTop = headerEl.offsetHeight; measure(); }).observe(headerEl);
  var settle = 0;
  window.addEventListener("scroll", function () {
    if (settle) clearTimeout(settle);
    settle = setTimeout(function () { settle = 0; measure(); }, 400);
  }, { passive: true });
})();

/* The reading-progress line on an article — the thin bar pinned to the top
 * edge of the screen that fills from the left as the reader moves through
 * the post (blog.google's). Present only where the page has
 * [data-read-progress]; the article's own extent (data-read-progress names
 * its selector, default .post) is what it measures: empty at the top of the
 * page, full once the post's end has come into view.
 *
 * Driven off scroll (Lenis emits native scroll events, so this needs no hook
 * into it) and written to a --p custom property the CSS scales the bar by,
 * so the work per frame is one transform. Liquid: the same script, the same
 * element in the article template.
 */
(function () {
  var bar = document.querySelector("[data-read-progress]");
  if (!bar) return;
  var post = document.querySelector(bar.getAttribute("data-read-progress") || ".post");
  if (!post) return;

  var ticking = false;
  function update() {
    ticking = false;
    var r = post.getBoundingClientRect();
    var y = window.scrollY;
    // Empty at the top of the page, full the moment the post's last line
    // reaches the foot of the screen — the reader is done — and linear in
    // between.
    var end = y + r.bottom - window.innerHeight;
    var p = end > 0 ? y / end : 1;
    p = Math.max(0, Math.min(1, p));
    bar.style.setProperty("--p", p.toFixed(4));
    bar.setAttribute("aria-valuenow", Math.round(p * 100));
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }
  update();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll);
})();

/* The "More from <category>" slider at the foot of an article: a scroll-
 * snapping track paged by dots. Four pages — three cards a page on desktop,
 * one a page on a phone (where only the first four cards exist; the CSS
 * hides the rest). The dots are built here from what is visible, so the
 * count follows the layout, and clicking one scrolls the track a page.
 *
 * Standalone, as {{ 'blog-related.js' | asset_url | script_tag }}.
 */
(function () {
  var roots = [].slice.call(document.querySelectorAll("[data-related]"));
  if (!roots.length) return;

  roots.forEach(function (root) {
    var track = root.querySelector("[data-related-track]");
    var dots = root.querySelector("[data-related-dots]");
    var prev = root.querySelector("[data-related-prev]");
    var next = root.querySelector("[data-related-next]");
    if (!track || !dots) return;

    function goTo(p) {
      track.scrollTo({ left: p * pageWidth(), behavior: "smooth" });
    }

    function cards() {
      return [].slice.call(track.children).filter(function (c) { return getComputedStyle(c).display !== "none"; });
    }

    /** Cards per page = how many fit the track's width. */
    function perPage() {
      var list = cards();
      if (!list.length) return 1;
      var w = list[0].getBoundingClientRect().width;
      return Math.max(1, Math.round(track.clientWidth / (w || track.clientWidth)));
    }

    function pageWidth() { return track.clientWidth; }

    function current() {
      return Math.round(track.scrollLeft / Math.max(1, pageWidth()));
    }

    /** The arrows are positioned off the track's box (CSS reads --rel-top /
     *  --rel-h on the section), so they centre on the cards, not the title
     *  or the dots. */
    function place() {
      root.style.setProperty("--rel-top", track.offsetTop + "px");
      root.style.setProperty("--rel-h", track.offsetHeight + "px");
    }

    function build() {
      place();
      var n = Math.max(1, Math.ceil(cards().length / perPage()));
      dots.textContent = "";
      for (var i = 0; i < n; i++) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "rel-dot";
        b.setAttribute("aria-label", "Page " + (i + 1) + " of " + n);
        b.dataset.page = String(i);
        b.addEventListener("click", function (e) { goTo(+e.currentTarget.dataset.page); });
        dots.appendChild(b);
      }
      sync();
    }

    function sync() {
      var at = current();
      var n = dots.children.length;
      [].slice.call(dots.children).forEach(function (d, i) {
        d.classList.toggle("is-current", i === at);
        d.setAttribute("aria-current", i === at ? "true" : "false");
      });
      // The arrows stop at the ends rather than wrapping — as the category
      // rows' do — and say so (opacity + cursor, never pointer-events: none,
      // which would let a click fall through to whatever is beneath).
      if (prev) prev.disabled = at <= 0;
      if (next) next.disabled = at >= n - 1;
    }

    if (prev) prev.addEventListener("click", function () { goTo(Math.max(0, current() - 1)); });
    if (next) next.addEventListener("click", function () { goTo(Math.min(dots.children.length - 1, current() + 1)); });

    var settle = 0;
    track.addEventListener("scroll", function () {
      clearTimeout(settle);
      settle = setTimeout(sync, 60);
    }, { passive: true });

    // Images load after the first placement and can change the track's height.
    [].slice.call(track.querySelectorAll("img")).forEach(function (img) { img.addEventListener("load", place); });
    var resizing = 0;
    window.addEventListener("resize", function () {
      clearTimeout(resizing);
      resizing = setTimeout(build, 120);
    });

    build();
  });
})();

/* The "member-grid" list at the foot of artist-profile articles (e.g.
 * "More Stray Kids Profiles"). That markup comes from the article's own
 * rich-text body, not this section's Liquid, so it isn't wrapped or given
 * arrow buttons ahead of time — this finds any ul.member-grid in the post
 * body, wraps it, and turns it into a scroll-snapping row with prev/next
 * arrows (same visual language as the "More from…" slider above).
 *
 * Standalone, as {{ 'blog-related.js' | asset_url | script_tag }}.
 */
(function () {
  var lists = [].slice.call(document.querySelectorAll(".post-body ul.member-grid"));
  if (!lists.length) return;

  lists.forEach(function (list) {
    if (list.closest(".member-carousel")) return; // already enhanced

    var wrap = document.createElement("div");
    wrap.className = "member-carousel";
    list.parentNode.insertBefore(wrap, list);
    wrap.appendChild(list);
    list.classList.add("member-track");

    var prev = document.createElement("button");
    prev.type = "button";
    prev.className = "member-arrow member-arrow--prev";
    prev.setAttribute("aria-label", "Previous");
    prev.innerHTML = '<svg viewBox="0 0 17 14" width="15" height="12" fill="none" aria-hidden="true"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="2"/></svg>';

    var next = document.createElement("button");
    next.type = "button";
    next.className = "member-arrow member-arrow--next";
    next.setAttribute("aria-label", "Next");
    next.innerHTML = '<svg viewBox="0 0 17 14" width="15" height="12" fill="none" aria-hidden="true"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2"/></svg>';

    wrap.appendChild(prev);
    wrap.appendChild(next);

    function itemStep() {
      var first = list.children[0];
      if (!first) return list.clientWidth;
      var style = getComputedStyle(list);
      var gap = parseFloat(style.columnGap || style.gap || "0") || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      return list.scrollWidth - list.clientWidth;
    }

    function sync() {
      var max = maxScroll();
      var fits = max <= 1;
      prev.disabled = fits || list.scrollLeft <= 1;
      next.disabled = fits || list.scrollLeft >= max - 1;
      wrap.classList.toggle("member-carousel--static", fits);
    }

    function scrollDir(dir) {
      var step = itemStep();
      var perView = Math.max(1, Math.floor(list.clientWidth / step));
      list.scrollTo({ left: list.scrollLeft + dir * perView * step, behavior: "smooth" });
    }

    prev.addEventListener("click", function () { scrollDir(-1); });
    next.addEventListener("click", function () { scrollDir(1); });

    var settle = 0;
    list.addEventListener("scroll", function () {
      clearTimeout(settle);
      settle = setTimeout(sync, 60);
    }, { passive: true });

    var resizing = 0;
    window.addEventListener("resize", function () {
      clearTimeout(resizing);
      resizing = setTimeout(sync, 120);
    });

    [].slice.call(list.querySelectorAll("img")).forEach(function (img) {
      img.addEventListener("load", sync);
    });

    sync();
  });
})();

/* The product card's variant picker (the cards the article body carries,
 * scripts/extract-bodies.py). A card with more than one variant has a
 * <select> per option and its variants on data-variants; picking one
 * switches the price (sale or not), the sold-out tab, the CTA's label and
 * where it goes (…?variant=<id>). Vanilla, so it ports to Liquid as-is.
 */
(function () {
  /* Prices come as cents and go out in the shop's money format
     ("{{amount_with_comma_separator}} €", "CHF {{amount}}" …), from the
     section root's data-money-format. */
  var root = document.querySelector(".nolae-blog");
  var FORMAT = (root && root.getAttribute("data-money-format")) || "{{amount}} €";
  var ADD = (root && root.getAttribute("data-s-add")) || "Hinzufügen";
  var VIEW = (root && root.getAttribute("data-s-view")) || "Produkt ansehen";
  function euro(cents) {
    var n = cents / 100;
    var comma = FORMAT.indexOf("comma_separator") !== -1;
    var noDec = FORMAT.indexOf("no_decimals") !== -1;
    var s = noDec ? String(Math.round(n)) : n.toFixed(2);
    if (comma) s = s.replace(".", ",");
    if (!noDec) {
      var parts = s.split(comma ? "," : ".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? "." : ",");
      s = parts.join(comma ? "," : ".");
    }
    return FORMAT.replace(/\{\{\s*[a-z_]+\s*\}\}/, s).replace(/<[^>]*>/g, "");
  }

  function wire(card) {
    var variants;
    try { variants = JSON.parse(card.getAttribute("data-variants") || "[]"); } catch (e) { return; }
    var selects = [].slice.call(card.querySelectorAll(".product-card__opt"));
    if (!variants.length || !selects.length) return;
    var cta = card.querySelector(".product-card__cta");
    var label = cta && cta.querySelector("span");
    var badge = card.querySelector(".product-card__badge");
    var prices = card.querySelector(".product-card__prices");
    var img = card.querySelector(".product-card__media img");
    if (img && !img.getAttribute("data-cover")) {
      img.setAttribute("data-cover", img.getAttribute("src") || "");
      if (img.getAttribute("srcset")) img.setAttribute("data-cover-srcset", img.getAttribute("srcset"));
    }

    function current() {
      var chosen = selects.map(function (s) { return s.value; });
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < chosen.length; j++) if (variants[i].o[j] !== chosen[j]) { ok = false; break; }
        if (ok) return variants[i];
      }
      return null;
    }

    function apply() {
      var v = current();
      if (!v) return;
      var sale = v.c && v.p && v.c > v.p;
      if (prices) {
        prices.innerHTML = '<span class="product-card__price' + (sale ? " is-sale" : "") + '">' + euro(v.p) + "</span>"
          + (sale ? '<s class="product-card__compare">' + euro(v.c) + "</s>" : "");
      }
      card.classList.toggle("is-sold-out", !v.a);
      if (badge) badge.hidden = v.a;
      if (cta) {
        cta.href = v.u;
        cta.setAttribute("data-variant-id", v.id);
        if (label) label.textContent = v.a ? ADD : VIEW;
        cta.classList.toggle("product-card__cta--view", !v.a);
      }
      if (img) {
        // the variant's own picture, or the product's cover for one without
        var want = v.i || img.getAttribute("data-cover");
        if (want && img.getAttribute("src") !== want) {
          if (v.i) { img.removeAttribute("srcset"); img.removeAttribute("sizes"); img.src = v.i; }
          else { img.src = want; if (img.getAttribute("data-cover-srcset")) img.srcset = img.getAttribute("data-cover-srcset"); }
        }
      }
    }
    selects.forEach(function (s) { s.addEventListener("change", apply); });
    apply();
  }

  /* "Hinzufügen": add the chosen variant to the cart without leaving the
     post. A sold-out variant's CTA ("Produkt ansehen") keeps its link.
     Same loading → added → revert sequence as the homepage's quick-add
     button: "…" + is-loading while the request is in flight, ADDED label +
     is-added (green, icon hidden) on success, back to normal after 3s. */
  var ADDED = (root && root.getAttribute("data-s-added")) || "Hinzugefügt";
  function addToCart(card, cta) {
    var id = cta.getAttribute("data-variant-id");
    if (!id || cta.classList.contains("is-loading") || cta.classList.contains("is-added")) return;
    var addUrl = card.getAttribute("data-add-url") || "/cart/add";
    var cartUrl = card.getAttribute("data-cart-url") || "/cart";
    var lbl = cta.querySelector("span");
    var original = lbl ? lbl.textContent : "";
    cta.setAttribute("aria-busy", "true");
    cta.classList.add("is-loading");
    if (lbl) lbl.textContent = "...";
    fetch(addUrl + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error("add failed");
      return fetch(cartUrl + ".js").then(function (r2) { return r2.json(); });
    }).then(function (cart) {
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: { cart: cart, openMiniCart: !!(window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === "drawer") }
      }));
      cta.classList.remove("is-loading");
      cta.classList.add("is-added");
      if (lbl) lbl.textContent = ADDED;
      setTimeout(function () {
        cta.classList.remove("is-added");
        if (lbl) lbl.textContent = original;
      }, 3000);
    }).catch(function () {
      cta.classList.remove("is-loading");
      if (lbl) lbl.textContent = original;
      window.location.href = cta.href;   // the product page can explain
    }).then(function () { cta.removeAttribute("aria-busy"); });
  }
  document.addEventListener("click", function (e) {
    var cta = e.target.closest && e.target.closest(".nolae-blog .product-card__cta");
    if (!cta) return;
    var card = cta.closest(".product-card");
    if (!card || cta.classList.contains("product-card__cta--view")) return;
    e.preventDefault();
    addToCart(card, cta);
  });

  function init() {
    // The section renders one card per product in the article's
    // blog.products metafield, in a hidden list; each is moved into the
    // body's placeholder for that handle (scripts/extract-bodies.py writes
    // <div class="blog-product" data-handle="…">).
    [].slice.call(document.querySelectorAll(".nolae-blog .blog-product[data-handle]")).forEach(function (slot) {
      var card = document.querySelector('.nolae-blog [data-blog-product="' + slot.getAttribute("data-handle").replace(/"/g, "") + '"] .product-card');
      if (card) { slot.appendChild(card); slot.classList.add("is-filled"); }
      else slot.hidden = true;
    });
    [].slice.call(document.querySelectorAll(".product-card[data-variants]")).forEach(wire);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

/* The lyrics on a lyrics post ([data-lyrics], the lyrics template): two
 * labels above the lines — Original | Translation (from the block's
 * data-s-* attributes, so they are translatable). On a desktop the CSS lays
 * the two texts out side by side and the labels are the column headings;
 * on a phone they are tabs, and each line carries both texts, so a tab
 * simply shows one and hides the other. Original is the default. Both
 * texts are in the HTML either way, for the index and for assistive tech.
 * Vanilla, so it ports to Liquid as-is.
 */
(function () {
  var box = document.querySelector("[data-lyrics]");
  if (!box) return;
  var tabs = document.createElement("div");
  tabs.className = "ly-tabs";
  tabs.setAttribute("role", "tablist");
  var MODES = ["original", "translation"];
  var mode = "";
  var buttons = MODES.map(function (m) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "ly-tab";
    b.setAttribute("role", "tab");
    b.setAttribute("data-mode", m);
    var root = document.querySelector(".nolae-blog");
    b.textContent = box.getAttribute("data-s-" + m) || (root && root.getAttribute("data-s-" + m)) || m;
    b.addEventListener("click", function () { setMode(m); });
    tabs.appendChild(b);
    return b;
  });
  box.insertBefore(tabs, box.firstChild);
  function setMode(m) {
    if (m === mode) return;
    mode = m;
    box.classList.toggle("is-original", m === "original");
    box.classList.toggle("is-translation", m === "translation");
    buttons.forEach(function (b) {
      var on = b.getAttribute("data-mode") === m;
      b.classList.toggle("is-on", on);
      b.setAttribute("aria-selected", on ? "true" : "false");
    });
  }
  setMode("original");
})();
